module.exports = __webpack_public_path__ + "static/media/01_Series_2_Ep_1-Foodtopia.4bf64e31.jpg";